// Fallback manifest. Drop files in /public/media and list them here; anything uploaded through
// the admin Media Manager (slot-matched) takes priority over these entries.
// Each item: { kind: "video" | "image", src, poster?, title, category, caption, alt }
export const MEDIA_MANIFEST = {
  hero: [],
  idea: [],
  showcase: [],
  story: [],
  oneshoot: [],
  case: [],
  industries: [],
  "service-strategy": [],
  "service-content": [],
  "service-paid": [],
  "service-websites": [],
  "service-systems": [],
  about: [],
  library: [],
};

// Clearly-labelled placeholders shown until real media exists for a slot.
export const PLACEHOLDERS = {
  hero: [
    { label: "Factory footage", kind: "video" },
    { label: "Angela filming on site", kind: "video" },
    { label: "Product close up", kind: "video" },
    { label: "Finished social content", kind: "video" },
  ],
  idea: [{ label: "Slow warehouse or production b-roll", kind: "video" }],
  showcase: [
    { label: "Vertical video", kind: "video", category: "Food distribution", caption: "Turning the warehouse into the story." },
    { label: "Vertical video", kind: "video", category: "Food manufacturing", caption: "Showing customers how the product actually gets made." },
    { label: "Vertical video", kind: "video", category: "Food safety", caption: "Making a technical industry understandable." },
    { label: "Vertical video", kind: "video", category: "Packaging", caption: "Turning manufacturing knowledge into content buyers care about." },
  ],
  story: [
    { label: "Angela filming inside a business", kind: "image" },
    { label: "Baxter talking with a client", kind: "image" },
    { label: "Behind the scenes on a shoot", kind: "image" },
  ],
  oneshoot: [{ label: "One shoot, wide shot of the day", kind: "video" }],
  case: [
    { label: "Case study media 01", kind: "video" },
    { label: "Case study media 02", kind: "video" },
    { label: "Case study media 03", kind: "video" },
  ],
  industries: [{ label: "Industry b-roll", kind: "image" }],
  "service-strategy": [{ label: "Strategy session photo", kind: "image" }],
  "service-content": [{ label: "Content production b-roll", kind: "video" }],
  "service-paid": [{ label: "Ad creative example", kind: "video" }],
  "service-websites": [{ label: "Website we built", kind: "image" }],
  "service-systems": [{ label: "Custom system in use", kind: "image" }],
  about: [{ label: "Angela and Baxter on location", kind: "image" }],
  library: [],
};
